// extracted by mini-css-extract-plugin
module.exports = {"organizerResult":"OrganizerResult_organizerResult__1ahsn","organizerIcon":"OrganizerResult_organizerIcon__DvAEg","organizerName":"OrganizerResult_organizerName___lERq"};